import { serviceRoles } from "config/access";
import { ASSESSMENT } from "constants/routes";
import { checkAccess } from "helpers/auth";
import AssessmentPage from "./container/AssessmentPage";

export default function getSettingsRoute(userAuth) {
  const { account, harmony } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [harmony.name]: [harmony.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: ASSESSMENT,
    withSidebar: true,
    withAppBar: true,
    component: AssessmentPage,
  };
}
